import React from 'react'

export default function Card(props) {

const sections = props.newsSections.join(",");

  return (
    <div className="card">
      <div className="content">
        <div className="img">
          <a href={props.newsUrl} target="_blank" rel="noopener noreferrer">
            <img src={props.newsImgSrc} alt={props.newsImgAlt} />
          </a>
        </div>
        <div className="article-details">
          <div>
            <h6 className="date">{props.newsDatePublished}</h6>
            <h6 className="sections">{sections}</h6>
            <a href={props.newsUrl} target="_blank" rel="noopener noreferrer">
              <h1 className="title">{props.newsTitle}</h1>
              <h2 className="subheadline">{props.newsSubHeadline}</h2>
            </a>
          </div>
          <div className="date-likes">
            <h6 className="time-to-read">{props.newsTimetoRead}</h6>
            <h6>{props.newsLikes} &#128420;</h6>
          </div>
        </div>
      </div>
    </div>
  )
}

